var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-row" },
      [
        _c("app-checkbox", {
          attrs: {
            label: _vm.t("app-program-delivery-community-based"),
            required: _vm.required,
            description: _vm.t(
              "app-program-delivery-community-based-description"
            ),
          },
          on: {
            input: function ($event) {
              return _vm.onInput($event, "community")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-row" },
      [
        _c("app-checkbox", {
          attrs: {
            label: _vm.t("app-program-delivery-site-based"),
            required: _vm.required,
            description: _vm.t("app-program-delivery-site-based-description"),
          },
          on: {
            input: function ($event) {
              return _vm.onInput($event, "siteBased")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-row" },
      [
        _c("app-checkbox", {
          attrs: {
            label: _vm.t("app-program-delivery-e-mentoring"),
            required: _vm.required,
            description: _vm.t("app-program-delivery-e-mentoring-description"),
          },
          on: {
            input: function ($event) {
              return _vm.onInput($event, "eMentoring")
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }